<ui-card class="payment-info" [class.loading]="!cards">
    <app-segment-header
        title="{{ 'settings.payment-information.header' | translate }}"
        editLabel="{{ 'settings.payment-information.editLabel' | translate }}"
        (edit)="edit.emit()"
    ></app-segment-header>

    <ng-container *ngIf="cards?.[0] as card">
        <ui-card class="credit-card" variant="outline">
            <strong>{{ card.brand }} ****{{ card.last4 }}</strong>
            {{ 'settings.payment-information.expiryLabel' | translate }} {{ card.expMonth }}/{{ card.expYear }}
            <img
                class="card"
                [src]="BRAND_LOGOS[card.brand] ? '/assets/img/billing/cards/' + BRAND_LOGOS[card.brand] : undefined"
            />
        </ui-card>

        <ui-card class="address" variant="outline">
            <ng-container *ngIf="card.addressLine1; else noBillingAddress">
                <span>{{ card.name }}</span>
                <span>{{ card.addressLine1 }}</span>
                <span>{{ card.addressCity }}, {{ card.addressState }}{{ card.addressZip }}</span>
                <span>{{ card.addressCountry }}</span>
            </ng-container>
            <ng-template #noBillingAddress>
                {{ 'settings.payment-information.noBillingAddressMessage' | translate }}
            </ng-template>
        </ui-card>
    </ng-container>

    <ui-card *ngIf="!cards?.length" variant="outline">
        {{ 'settings.payment-information.noPaymentMethodMessage' | translate }}
    </ui-card>
</ui-card>
